export const queryKeys = {
  reservations: params => ['reservations', params || {}],
  reservation: recordId => ['reservation', recordId],
  todayReservations: params => ['reservations', 'today', params || {}],
  upcomingReservations: params => ['reservations', 'upcoming', params || {}],
  actualPaxEntries: recordId => ['reservation', recordId, 'actual-pax-entries'],
  callLeads: params => ['call-leads', params || {}],
  callLeadByPhone: phone => ['call-lead', 'phone', phone],
  users: () => ['users'],
  analytics: params => ['analytics', params || {}],
  slotSummary: params => ['analytics', 'slot-summary', params || {}],
  slotAnalytics: params => ['analytics', 'slot-analytics', params || {}],
  guestBook: params => ['guest-book', params || {}],
  advances: params => ['accounts', 'advances', params || {}],
  refunds: params => ['accounts', 'refunds', params || {}]
};
